<template>
  <UiCard class="report_wrapper">
    <div slot="title">
      <ReportTitle />
    </div>

    <div slot="content">
      <ReportDateConfigure />

      <ReportChart />
    </div>
  </UiCard>
</template>

<script>
import UiCard from '@/components/card/UiCard.vue'
import ReportDateConfigure from './ReportDateConfigure.vue'
import ReportTitle from './ReportTitle.vue'
import ReportChart from './ReportChart.vue'

import currentApplicationMixin from '../mixins/currentApplicationMixin'

import { CURRENT_YEAR, CURRENT_MONTH } from '@/config/date'

import { FinancesService } from '@/services/finances.service'

export default {
  components: {
    UiCard,
    ReportDateConfigure,
    ReportTitle,
    ReportChart,
  },
  mixins: [currentApplicationMixin],
  data() {
    return {
      loading: false,
      error: false,
    }
  },
  watch: {
    '$route.query': {
      handler: 'getApplicationReport',
      immediate: true,
    },
  },
  destroyed() {
    this.$store.commit('application/CLEAR_CURRENT_REPORT')
  },
  methods: {
    /**
     * Send request to backend for get one Application by id report chart data.
     * Then run mutation `SET_CURRENT_REPORT` in vuex.
     *
     * @returns {Object} data Response wrapper. Contains chart data of `Application`.
     * */
    async getApplicationReport() {
      if (!this.appLogin) return

      this.loading = true
      try {
        const params = {
          year: this.$route.query.year ?? CURRENT_YEAR,
          month: this.$route.query.month ?? CURRENT_MONTH,
          domain: this.appLogin,
        }

        const { data } = await FinancesService.getReport(params)

        this.$store.commit('application/SET_CURRENT_REPORT', data)
      } catch (error) {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
        this.error = error.message
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.date-options {
  @include createFlex(flexbox, nowrap, row, flex-start, center, center);
}
</style>
